import { render, staticRenderFns } from "./MasterplanSquaresSettings.vue?vue&type=template&id=1f5dbad6&"
import script from "./MasterplanSquaresSettings.vue?vue&type=script&lang=js&"
export * from "./MasterplanSquaresSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports